import "./PaymentHeader.css";

import { CreditCard } from "lucide-react";

export default function PaymentHeader(){

    return(

        <header className="payment-header">

            <div className="payment-header-icon">

                <CreditCard size={34}/>

            </div>

            <div>

                <h2>

                    انتخاب روش پرداخت

                </h2>

                <p>

                    روش پرداخت سفارش خود را انتخاب نمایید.

                </p>

            </div>

        </header>

    );

}